import { useTranslation } from "react-i18next";
import { NavLink, Outlet, useLocation, useParams } from "react-router-dom";
import { useAppStore } from "../../stores/RootStore";
import { Separator } from "../../ui/Separator";
import { Header } from "../../components/Header";
import { DivisionsGrid } from "./DivisionsGrid";

export const Divisions = () => {
    let {id} = useParams();
    const { t } = useTranslation();
    const location = useLocation();
    const currentSite = useAppStore().currentSite
    const divisions = useAppStore().divisions;
  
    function empty() {}
  
    return (
      <div className="flex flex-col w-full h-full">
        <div className="flex-none flex w-full h-14 px-6 justify-between items-center bg-background">
            <div className="flex text-base items-center gap-1">
            <NavLink to={"/"}>
                <span className="font-medium">{currentSite?.name ? currentSite?.name : "..."}</span> 
            </NavLink>
            <span>/</span>
            <NavLink to={"/data/directories"}>
                <span className="font-medium">{t("directories")}</span>
            </NavLink> 
            
            <span>/</span>
            {location.pathname == "/data/divisions/" || location.pathname == "/data/divisions" ? <span>{t("divisions")}</span> : <NavLink to={"/data/divisions"}><span>{t("divisions")}</span></NavLink>}
            {(id || location.pathname == "/data/divisions/new") && <span>/</span>}
            {id && <span>{divisions?.find(n => n.id == id)?.attributes.name}</span>}
            {location.pathname == "/data/divisions/new" && <span>{t('adding_division')}</span>}
            </div>
        </div>
        <Separator className="flex-none"/>
        {id || location.pathname == "/data/divisions/new" ? 
          <Outlet /> : 
            <div className="flex flex-col w-full h-full mx-auto overflow-hidden bg-background">
              <Header name={t('divisions')} backName={t("directories")} backLink={"/data/directories"}/>
              <DivisionsGrid onClose={empty}/>
            </div>
        }
      </div>
    )
  };